import { h, Component } from 'preact';
import style from './index.less'
import {classNames} from 'lib/helpers'
export default (props)=>{
    let classes = [style.cardNumber]
    props.class && classes.push(props.class)
    return (
        <div class={classNames(classes)}>
            ****
            &nbsp;
            ****
            &nbsp;
            ****
            &nbsp;
            {props.cardNumber.replace(/\*/g, '')}
        </div>
    )
}



// WEBPACK FOOTER //
// ./components/elements/CreditCardNumber/index.js